import { HTTP, authHeader } from './http-service';

class BrandmisuseSearchService {
  search(payload) {
    return HTTP.post(`/DisputesBrandMisuseSearch`, payload, { headers: authHeader() }).then(
      (response) => {
        return response.data;
      }
    );
  }

  advancedSearch(payload) {
    return HTTP.post(`/DisputesBrandMisuseSearch/advance`, payload, { headers: authHeader() }).then(
      (response) => {
        return response.data;
      }
    );
  }

  getFunnelData() {
    return HTTP.get(`/DisputesBrandMisuseSearch/funnel`, { headers: authHeader() }).then(
      (response) => {
        return response.data;
      }
    );
  }

  getFunnelDataForYear(year) {
    return HTTP.get(`/DisputesBrandMisuseSearch/funnel/${year}`, { headers: authHeader() }).then(
      (response) => {
        return response.data;
      }
    );
  }

  getBrandmisuseFollowUpDateCount() {
    return HTTP.post(`/DisputesBrandMisuseSearch/brandMisuseFollowUpDateCount`, {}, { headers: authHeader() }).then((response) => {
      return response.data;
      });
  }
}

export default new BrandmisuseSearchService();
